import React from 'react';
import { Button } from 'reactstrap';

import * as Constants from './Constants.js';

function validateEmail(email) {
  var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

class JobDetails extends React.Component {
  
  constructor(props) {
    super(props);
    var d = new Date();
    d += " UTC";
    var descriptionPlaceholder = Constants.epilogosMemeDescriptionPrefix + d.toString();
    this.state = {
      email : "",
      description : descriptionPlaceholder,
      emailValid : false,
      submitValid : false,
      submitPending : this.props.currentDesign.submitPending
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.updateEmailValidationState = this.updateEmailValidationState.bind(this);
    this.updateJobDesignRequirements = this.updateJobDesignRequirements.bind(this);
  }
  
  UNSAFE_componentWillMount() {
    this.props.updateDesign(this.state);
  }
  
  handleInputChange(event) {
    console.log("event.target.name", event.target.name);
    console.log("event.target.value", event.target.value);
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name] : value
    }, function() {
      if (name === 'email') { this.updateEmailValidationState(); }
      this.props.updateDesign(this.state);
    });
  }
  
  handleClick(event) {
    console.log("handleClick", event.target.name);
    if (event.target.name === 'submitJob') {
      this.setState({
        submitPending: true,
      }, function() {
        this.props.updateDesign(this.state);
      })
    }
    document.activeElement.blur();
  }
  
  updateEmailValidationState() {
    console.log("this.jobEmail.value", this.jobEmail.value, this.state.email.length);
    console.log("validateEmail(this.jobEmail.value)", validateEmail(this.jobEmail.value));
    this.setState({ emailValid : validateEmail(this.jobEmail.value) }, ()=>{this.updateJobDesignRequirements()});
    return validateEmail(this.jobEmail.value);
  }
  
  updateJobDesignRequirements() {
    let diffTest = false;
    let design = this.props.currentDesign;
    let requirements = [];
    let warnings = [];
    let makeListElementFromArray = function(a) {
      return <li key={a}>{a}</li>;
    }
//     if (!design.emailValid) {
    if (!validateEmail(this.state.email)) {
      requirements.push("Please add a valid email address");
    }
    if (design.pastedData && !design.alphabetValid && (design.alphabetValid !== null)) {
      requirements.push("Please match FASTA sequence alphabet to state model alphabet");
    }
    if ((!design.inputFormat) || ((design.inputFormat === "BED") && !design.inputIntervals) || ((design.inputFormat === "FASTA") && !design.inputSequences)) {
      requirements.push("Please paste or upload BED or FASTA data");
    }
/*
    if (parseInt(design.motifMaximumWidth) <= parseInt(design.motifMinimumWidth)) {
      requirements.push("Please set the motif maximum width value higher than the minimum value");
    }
*/
    if (parseInt(design.motifMinimumWidth) < parseInt(Constants.epilogosMemeAllowedMotifMinimumWidth)) {
      requirements.push("Please set the motif minimum width to " + Constants.epilogosMemeAllowedMotifMinimumWidth + " or higher");
    }
    if (parseInt(design.motifMinimumWidth) > parseInt(design.motifMaximumWidth)) {
      requirements.push("Please set the motif minimum width to a value less than the maximum width");
    }
    if (parseInt(design.motifNumber) <= 0) {
      requirements.push("Please set the motif number to a positive integer value");
    }
    if (parseInt(design.maxSize) <= 0) {
      requirements.push("Please set the maximum size value to a positive integer value");
    }
    if (design.inputFormat && (design.inputFormat === "BED") && design.inputIntervals) {
      diffTest = true;
      let filteredInputIntervals = [];
      for (var idx = 0; idx < design.inputIntervals.length; idx++) {
        /* console.log("design.motifMinimumWidth", design.motifMinimumWidth); */
        var interval = design.inputIntervals[idx];
        var intervalElems = interval.split('\t');
        var intervalStop = parseInt(intervalElems[2]);
        var intervalStart = parseInt(intervalElems[1]);
        var intervalDiff = intervalStop - intervalStart;
        if (intervalDiff >= parseInt(design.motifMinimumWidth) * parseInt(Constants.epilogosMemeChromatinStateCallIntervalWidth)) {
          filteredInputIntervals.push(interval);
        }
        else {
          /* console.log(`Filtered out: ${interval[0]}:${intervalStart}-${intervalStop} -> ${intervalDiff} vs ${parseInt(design.motifMinimumWidth) * parseInt(Constants.epilogosMemeChromatinStateCallIntervalWidth)}`); */
          diffTest = false;
          /* break; */ 
        }
      }
      design.filteredInputIntervals = filteredInputIntervals;
      if (!diffTest) {
        warnings.push("Intervals were filtered for those longer than the specified motif minimum width");
        if (filteredInputIntervals.length === 0) {
          requirements.push("No intervals were added after filtering. Please paste or upload intervals of sufficient length (200 nt per residue) or adjust minimum/maximum motif residue length in the Advanced Options settings window");
        }
      }
    }
    if (design.inputFormat && (design.inputFormat === "FASTA") && design.inputSequences) {
      diffTest = true;
      let filteredInputSequences = [];
      Object.keys(design.inputSequences).forEach(function(key) {
        var seqObj = design.inputSequences[key];
        var sequence = seqObj.seq;
        if (sequence.length >= parseInt(Constants.epilogosMemeDefaultMotifMinimumWidth)) {
          filteredInputSequences.push(sequence);
        }
        else {
          diffTest = false;
        }
      });
      design.filteredInputSequences = filteredInputSequences;
      if (!diffTest) {
        warnings.push("Sequences were filtered for those longer than the specified motif minimum width");
        if (filteredInputSequences.length === 0) {
          requirements.push("No sequences were added after filtering. Please paste or upload sequences of sufficient length or adjust minimum/maximum motif residue length in the Advanced Options settings window");
        }
      }
    }
    if ((requirements.length > 0) && (warnings.length === 0)) {
      this.state.submitValid = false;
      return (
        <div className="job-requirements">
          <h6>Requirements</h6>
          <ul>
            {requirements.map(makeListElementFromArray)}
          </ul>
        </div>
      )
    }
    else if ((requirements.length > 0) && (warnings.length > 0)) {
      this.state.submitValid = false;
      return (
        <div>
          <div className="job-requirements">
            <h6>Requirements</h6>
            <ul>
              {requirements.map(makeListElementFromArray)}
            </ul>
          </div>
          <div className="job-warnings">
            <h6>Warnings</h6>
            <ul>
              {warnings.map(makeListElementFromArray)}
            </ul>
          </div>
        </div>
      )
    }
    else if (warnings.length > 0) {
      this.state.submitValid = true;
      return (
        <div className="job-warnings">
          <h6>Warnings</h6>
          <ul>
            {warnings.map(makeListElementFromArray)}
          </ul>
        </div>
      )
    }
    this.state.submitValid = true;
    return null;
  }
  
  longSample = () => {
    if (!this.props.currentDesign || !Constants.epilogosMemeSamplesKV[this.props.currentDesign.genome]) return;
    return Constants.epilogosMemeSamplesKV[this.props.currentDesign.genome][this.props.currentDesign.sample];
  }
  
  longSiteDistribution = () => {
    if (!this.props.currentDesign) return;
    if (this.props.currentDesign.siteDistribution !== Constants.epilogosMemeDefaultMotifSiteDistribution) {
      return <span className="job-summary-label-value-advanced-option-nondefault">{Constants.epilogosMemeMotifSiteDistributions[this.props.currentDesign.siteDistribution]} of motif</span>
    }
    return <span>{Constants.epilogosMemeMotifSiteDistributions[this.props.currentDesign.siteDistribution]} of motif</span>;
  }
  
  decapitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toLowerCase() + s.slice(1)
  }
  
  longBackground = () => {
    if (!this.props.currentDesign) return;
    let result = `${Constants.epilogosMemeBackgrounds[this.props.currentDesign.background]}`;
    if (this.props.currentDesign.background === "zfs") {
      result = `${Constants.epilogosMemeBackgrounds[this.props.currentDesign.background]} (${this.props.currentDesign.sample})`;
    }
    result = "Background " + this.decapitalize(result);
    if (this.props.currentDesign.background !== Constants.epilogosMemeDefaultBackground) {
      return <span className="job-summary-label-value-advanced-option-nondefault">{result}</span>
    }
    return result;
  }
  
  longPrior = () => {
    if (!this.props.currentDesign) return;
    let result = Constants.epilogosMemePriors[this.props.currentDesign.prior];
    result += " prior model";
    if (this.props.currentDesign.prior !== Constants.epilogosMemeDefaultPrior) {
      return <span className="job-summary-label-value-advanced-option-nondefault">{result}</span>
    }
    return result;
  }
  
  longMaximumSize = () => {
    if (!this.props.currentDesign) return;
    if (this.props.currentDesign.maxSize !== Constants.epilogosMemeDefaultMaxSize) {
      return <span><span className="job-summary-label-value-advanced-option-nondefault">{this.props.currentDesign.maxSize}</span> residues (max. size)</span>
    }
    return `${this.props.currentDesign.maxSize} residues (max. size)`;
  }
  
  longMotifNumber = () => {
    if (!this.props.currentDesign) return;
    let result = this.props.currentDesign.motifNumber;
    if (this.props.currentDesign.motifNumber === 1) { result = `${result} motif`; } else result = `${result} motifs`;
    if (this.props.currentDesign.motifNumber !== Constants.epilogosMemeDefaultMotifNumber) {
      return <span className="job-summary-label-value-advanced-option-nondefault">{result}</span>
    }
    return result;
  }
  
  longMotifWidthRange = () => {
    if (!this.props.currentDesign) return;
    //console.log("this.props.currentDesign.motifMinimumWidth - this.props.currentDesign.motifMaximumWidth", parseInt(this.props.currentDesign.motifMinimumWidth), parseInt(this.props.currentDesign.motifMaximumWidth), (parseInt(this.props.currentDesign.motifMinimumWidth) === parseInt(this.props.currentDesign.motifMaximumWidth)));
    
    if ((parseInt(this.props.currentDesign.motifMinimumWidth) === parseInt(this.props.currentDesign.motifMaximumWidth)) && (parseInt(this.props.currentDesign.motifMinimumWidth) !== Constants.epilogosMemeDefaultMotifMinimumWidth)) {
      return <span>Size: <span className="job-summary-label-value-advanced-option-nondefault">{this.props.currentDesign.motifMinimumWidth}</span> residues long</span>
    }
    
    if ((parseInt(this.props.currentDesign.motifMinimumWidth) === parseInt(this.props.currentDesign.motifMaximumWidth)) && (parseInt(this.props.currentDesign.motifMinimumWidth) === Constants.epilogosMemeDefaultMotifMinimumWidth)) {
      return <span>Size: <span className="job-summary-label-value-advanced-option-default">{this.props.currentDesign.motifMinimumWidth}</span> residues long</span>
    }
    
    if ((parseInt(this.props.currentDesign.motifMinimumWidth) !== parseInt(this.props.currentDesign.motifMaximumWidth)) && ((this.props.currentDesign.motifMinimumWidth !== Constants.epilogosMemeDefaultMotifMinimumWidth) || (this.props.currentDesign.motifMaximumWidth !== Constants.epilogosMemeDefaultMotifMaximumWidth))) {
      return <span>Size range: <span className="job-summary-label-value-advanced-option-nondefault">{this.props.currentDesign.motifMinimumWidth}-{this.props.currentDesign.motifMaximumWidth}</span> residues</span>
    }
    
    if ((parseInt(this.props.currentDesign.motifMinimumWidth) !== parseInt(this.props.currentDesign.motifMaximumWidth)) && ((this.props.currentDesign.motifMinimumWidth === Constants.epilogosMemeDefaultMotifMinimumWidth) && (this.props.currentDesign.motifMaximumWidth === Constants.epilogosMemeDefaultMotifMaximumWidth))) {
      return <span>Size range: <span className="job-summary-label-value-advanced-option-default">{this.props.currentDesign.motifMinimumWidth}-{this.props.currentDesign.motifMaximumWidth}</span> residues</span>
    }
    
    return <span>Size unspecified</span>
  }
  
  longMemeVersion = () => {
    if (!this.props.currentDesign) return;
    let result = `MEME ${this.props.currentDesign.memeVersion}`;
    if (this.props.currentDesign.memeVersion !== Constants.epilogosMemeDefaultMemeVersion) {
      return <span className="job-summary-label-value-advanced-option-nondefault">{result}</span>
    }
    return result;
  }
  
  render() {
    let descriptionNotice = <div className="job-detail-notice">Edit the description field to give your analysis a custom title.</div>
    let emailNotice = <div className="job-detail-notice job-detail-notice-middle">An email address is required to submit and receive updates about the analysis.</div>
    return (
      <div style={{"paddingTop":"20px"}}>
        <div>
          {descriptionNotice}
          <label htmlFor="job-description" className="panel-label job-description-label">Description</label>
          <input id="job-description"
             name="description"
             className="job-description-textfield"
             type="text"
             value={this.state.description}
             onChange={this.handleInputChange}
             placeholder=""
             ref={(thisInput) => {this.jobDescription = thisInput}}
             />
        </div>
        <div className="panel-subsection-email">
          {emailNotice}
          <label htmlFor="job-email" className="panel-label job-email-label">Email <span className="job-email-panel-required">*</span></label>
          <input id="job-email"
             name="email"
             className={(!this.state.emailValid && this.state.email.length > 0) ? "job-email-textfield job-email-textfield-invalid" : (this.state.emailValid && this.state.email.length > 0) ? "job-email-textfield job-email-textfield-valid" : "job-email-textfield"}
             type="text"
             value={this.state.email}
             onChange={this.handleInputChange}
             placeholder="" 
             autoComplete="off"
             ref={(thisInput) => {this.jobEmail = thisInput}}
             />
        </div>
        <div>
          <label htmlFor="job-summary" className="panel-label job-summary-label">Summary</label>
          <div id="job-summary">
            <div className="job-summary-row">
              <div id="job-summary-genome" className="job-summary-label-value job-summary-label-value-basic-option">{this.props.currentDesign.genome}</div>
            </div>
            <div className="job-summary-row">
              <div id="job-summary-stateModel" className="job-summary-label-value job-summary-label-value-basic-option">{this.props.currentDesign.stateModel}</div>
            </div>
            <div className="job-summary-row">
              <div id="job-summary-sample" className="job-summary-label-value job-summary-label-value-basic-option">{this.props.currentDesign.sample} ({this.longSample()})</div>
            </div>
          </div>
          <div id="job-summary-advanced-options" className="job-summary-advanced-options">
            <div className="job-summary-row">
              <div id="job-summary-siteDistribution" className="job-summary-label-value job-summary-label-value-advanced-option">{this.longSiteDistribution()}</div>
            </div>
            <div className="job-summary-row">
              <div id="job-summary-background" className="job-summary-label-value job-summary-label-value-advanced-option">{this.longBackground()}</div>
            </div>
            <div className="job-summary-row">
              <div id="job-summary-prior" className="job-summary-label-value job-summary-label-value-advanced-option">{this.longPrior()}</div>
            </div>
            {/*
            <div className="job-summary-row">
              <div id="job-summary-maxSize" className="job-summary-label-value job-summary-label-value-advanced-option">{this.longMaximumSize()}</div>
            </div>
            */}
            <div className="job-summary-row">
              <div id="job-summary-motifNumber" className="job-summary-label-value job-summary-label-value-advanced-option">{this.longMotifNumber()}</div>
            </div>
            <div className="job-summary-row">
              <div id="job-summary-motifWidthRange" className="job-summary-label-value job-summary-label-value-advanced-option">{this.longMotifWidthRange()}</div>
            </div>
            <div className="job-summary-row">
              <div id="job-summary-memeVersion" className="job-summary-label-value job-summary-label-value-advanced-option">{this.longMemeVersion()}</div>
            </div>
          </div>
        </div>
        <div className="job-submit">
          {this.updateJobDesignRequirements()}
          <Button 
            className="btn-epilogos"
            color="primary" 
            size="sm"
            disabled={!this.state.submitValid}
            onClick={this.handleClick} 
            name="submitJob"
            ref={(thisButton) => {this.submit = thisButton}}>Submit
          </Button>
          <p></p>
        </div>
      </div>
    )
  }
}

export default JobDetails;